var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardMessageMarkasunreadNormalIcon = function SvgNewcsDashboardMessageMarkasunreadNormalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_message_markasunread_normal_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M91 546h14v14H91z",
    "data-name": "\\u77E9\\u5F62 534"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_message_markasunread_normal_icon_svg__a)",
    transform: "translate(-91 -546)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#f44336",
    "data-name": "\\u692D\\u5706 6",
    transform: "translate(101 546)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M94.498 559.998a2.59 2.59 0 0 1-2.6-2.569l.012-8.865a2.59 2.59 0 0 1 2.6-2.569h5.118a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6H94.51a1.387 1.387 0 0 0-1.4 1.37l-.012 8.865a1.387 1.387 0 0 0 1.4 1.369h6.991a1.387 1.387 0 0 0 1.4-1.37v-5.843a.6.6 0 0 1 .6-.6.6.6 0 0 1 .6.6v5.843a2.59 2.59 0 0 1-2.6 2.569Zm1-3.9a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h4a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6Zm0-3a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6Zm0-3a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h4a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6Z",
    "data-name": "\\u8054\\u5408 80"
  }))));
};
export default SvgNewcsDashboardMessageMarkasunreadNormalIcon;